import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CamelToTitlePipe } from "./camel-to-title.pipe";
import { SortPipe } from "./sort.pipe";
import { IsCheckboxColumnPipe } from "./is-checkbox-column.pipe";
import { IsCheckboxFilterPipe } from "./is-checkbox-filter.pipe";
import { ZipCodeMaskPipe } from "./masks/zip-code-mask.pipe";
import { OwnerTypePipe } from "./owner-type.pipe";
import { HidePhonePipe } from "./hide-phone.pipe";
import { ShareTypeUnitsPipe } from "./shareTypeUnits";
import { DisplayNamePipe } from "./display-name.pipe";

@NgModule({
  declarations: [
    CamelToTitlePipe,
    SortPipe,
    IsCheckboxColumnPipe,
    IsCheckboxFilterPipe,
    ZipCodeMaskPipe,
    OwnerTypePipe,
    ShareTypeUnitsPipe,
    HidePhonePipe,
    DisplayNamePipe,
  ],
  exports: [
    CamelToTitlePipe,
    SortPipe,
    IsCheckboxColumnPipe,
    IsCheckboxFilterPipe,
    ZipCodeMaskPipe,
    OwnerTypePipe,
    ShareTypeUnitsPipe,
    HidePhonePipe,
    DisplayNamePipe,
  ],
  imports: [CommonModule],
})
export class SharedPipesModule {}
